import { CampusTag } from "atlas-ds"

export function getCofinancementType(cofinancement: string) {
    if (
        process.env.NEXT_PUBLIC_COFINANCEMENT === 'ADEME_ALT_IMPACT'
        && cofinancement === 'ADEME_ALT_IMPACT'
    ) {
        return "ADEME_ALT_IMPACT"
    } else if (
        process.env.NEXT_PUBLIC_COFINANCEMENT === 'IATLAS'
        && cofinancement === "IA-tlas"
    ) {
        return "IATLAS"
    } else if (
        process.env.NEXT_PUBLIC_COFINANCEMENT === 'FNE'
        && cofinancement.startsWith('FNE')
    ) {
        return "FNE"
    }
}

export function CofinancementTag(props: { cofinancement: string }) {
    switch(getCofinancementType(props.cofinancement)) {
        case "IATLAS":
            return <CampusTag type="module"
                tooltipContent=<>
                    IA-tlas, formation intégralement financée exclusivement pour les entreprises de moins de 50 salariés selon les <a href="https://opco-atlas.fr/criteres-financement" target="_blank">critères de prise en charge</a> en vigueur.
                </>
            >IA-tlas</CampusTag>
        case "ADEME_ALT_IMPACT":
            return <CampusTag type="module">Alt'impact</CampusTag>
        case "FNE":
            return <CampusTag type="module" tooltipContent={<>
                <p>
                    Cette action de formation bénéficie du soutien de l’Etat au titre du FNE-Formation car elle concourt à la prise en compte et l’accélération des transitions numérique et/ou écologique.
                </p>
                <p>
                    <a href="https://www.opco-atlas.fr/article/comment-beneficier-du-fne-formation-pour-accompagner-les-transitions-numerique-et-ecologique-dans.html">
                        En savoir plus
                    </a>
                </p>
            </>}>FNE</CampusTag>
        default:
            return undefined
    }
}
